import styled from "styled-components";

export const SideNavItem = styled.div`
  height: 4.678rem;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0.938rem 1.563rem;
  color: ${(props) => (props.active ? "#1a5304" : "#525A6E")};
  background: ${(props) => (props.active ? "#FAFAFA" : "#EDF0F4")};
  box-shadow: ${(props) =>
    props.active
      ? "0 3.75rem 4rem rgba(101, 101, 101, 0.04), 0 0.5rem 0.5rem rgba(101, 101, 101, 0.02)"
      : ""};
  border-radius: 0.25rem;
  cursor: pointer;

  & > svg.icon {
    height: 1.125rem;
    width: 1.25rem;
    stroke: ${(props) => (props.active ? "#1a5304" : "#525A6E")};
  }

  p {
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5rem;
    margin-left: 1rem;
    display: ${(props) => (props.isMessage ? "none" : "")};
  }
`;
